"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientProcedureNoteType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientProcedureNoteType_Factory = /** @class */ (function () {
    function PatientProcedureNoteType_Factory() {
    }
    PatientProcedureNoteType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    PatientProcedureNoteType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return PatientProcedureNoteType_Factory;
}());
exports.PatientProcedureNoteType_Factory = PatientProcedureNoteType_Factory;
